import { BaseService } from '@/core/base-service';
import axios from 'axios';

export default class ProblemService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/problem');
  }

  public getOptions(): Promise<any> {
    return axios.get(this.endpointName + '/combobox');
  }

  public getPieChartData(problemId: any): Promise<any> {
    return axios.get(this.endpointName + '/piechart/' + problemId);
  }
}
